import React, { useState } from 'react';
// TODO: refactor this
// eslint-disable-next-line no-restricted-imports
import { useAsObservableSource } from 'mobx-react-lite';
import { observer } from 'src/utils/mobx-react';
import { MeetingsList } from 'src/domains/sportsbook/webview/components/meetingsList/MeetingsList';
import { FiltersState } from 'src/domains/layouts/webview/components/filters/Filters.state';
import { Filters } from 'src/domains/layouts/webview/components/filters/Filters';
import { FiltersScrollableWrapper } from 'src/domains/layouts/webview/components/filters/FiltersScrollableWrapper';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { getEventsList, SportMeetingsListState, SportType } from './SportMeetingsList.state';
import {
    SportMeetingsFiltersWrapper,
    SportMeetingsListWrapper,
} from 'src/domains/sportsbook/webview/components/containers/sportMeetingsList/SportMeetingsList.style';
import { SportMeetingsListFilterStrategy } from './SportMeetingsListFilterStrategy';
import { EventId } from 'src_common/common/websocket2/id/WebsocketId';
import { HorseRacingSelectedNew } from 'src/domains/sportsbook/webview/components/racing/NewRacingPage.state';
import { Collapse } from 'src/ui/components/collapse/sports/03/Collapse';
import { RaceWrapper } from 'src/domains/sportsbook/webview/components/racing/NewRacingPage.style';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';
import { SportRacesTypeParamType } from 'src/domains/layouts/state/router/newRouter/mainRouteTypes';

export interface SportMeetingsListPropsType {
    state: SportMeetingsListState;
    isBuilding: boolean;
    isLoading: boolean;
    selected: HorseRacingSelectedNew;
    sport: SportType;
    nameList?: string;
    onChoose?: (eventId: EventId) => void;
    filterType?: SportRacesTypeParamType;
}

const SportMeetingsListByCountry = observer('SportMeetingsListByCountry', (propsIn: SportMeetingsListPropsType) => {
    const common = useCommon();
    const props = useAsObservableSource(propsIn);
    const { state, sport, isBuilding, isLoading, selected, onChoose, filterType } = props;
    const eventsList = getEventsList(common, sport, isBuilding);

    if (eventsList === null) {
        return null;
    }

    if (filterType === 'international') {
        return (
            <>
                <Collapse
                    handleToggle={state.handleClickInternational}
                    isOpen={state.isOpenInternational}
                    title={
                        <I18n
                            langKey='events.sport-meetings-list.country.international'
                            defaultText='International'
                        />
                    }
                />

                <MeetingsList
                    events={state.filterEventsComputedInternational}
                    isBuilding={isBuilding}
                    isLoading={isLoading}
                    isOpen={state.isOpenInternational}
                    onChoose={onChoose}
                    selected={selected}
                />
            </>
        );
    }

    if (filterType === 'uk-ire') {
        return (
            <>
                <Collapse
                    handleToggle={state.handleClickUkAndIreland}
                    isOpen={state.isOpenUkAndIreland}
                    title={
                        <I18n
                            langKey='events.sport-meetings-list.country.uk-ireland'
                            defaultText='UK And Ireland'
                        />
                    }
                />

                <MeetingsList
                    events={state.filterEventsComputedUkIreland}
                    isBuilding={isBuilding}
                    isLoading={isLoading}
                    isOpen={state.isOpenUkAndIreland}
                    onChoose={onChoose}
                    selected={selected}
                />
            </>
        );
    }

    return (
        <>
            <Collapse
                handleToggle={state.handleClickUkAndIreland}
                isOpen={state.isOpenUkAndIreland}
                title={
                    <I18n
                        langKey='events.sport-meetings-list.country.uk-ireland'
                        defaultText='UK And Ireland'
                    />
                }
            />

            <MeetingsList
                events={state.filterEventsComputedUkIreland}
                isBuilding={isBuilding}
                isLoading={isLoading}
                isOpen={state.isOpenUkAndIreland}
                onChoose={onChoose}
                selected={selected}
            />

            <Collapse
                handleToggle={state.handleClickInternational}
                isOpen={state.isOpenInternational}
                title={
                    <I18n
                        langKey='events.sport-meetings-list.country.international'
                        defaultText='International'
                    />
                }
            />

            <MeetingsList
                events={state.filterEventsComputedInternational}
                isBuilding={isBuilding}
                isLoading={isLoading}
                isOpen={state.isOpenInternational}
                onChoose={onChoose}
                selected={selected}
            />
        </>
    );
});

const SportMeetingsListDefault = observer('SportMeetingsListDefault', (propsIn: SportMeetingsListPropsType) => {
    const common = useCommon();
    const props = useAsObservableSource(propsIn);
    const { state, sport, isBuilding, isLoading, selected, onChoose } = props;
    const eventsList = getEventsList(common, sport, isBuilding);
    if (eventsList === null) {
        return null;
    }

    return (
        <MeetingsList
            events={state.filterEventsComputed}
            onChoose={onChoose}
            selected={selected}
            isLoading={isLoading}
            isBuilding={isBuilding}
        />
    );
});

export interface PropsType {
    sport: SportType;
    selected: HorseRacingSelectedNew;
    isBuilding: boolean;
    isLoading: boolean;
    shared: true;
    onChoose?: (eventId: EventId) => void;
    filterType?: SportRacesTypeParamType;
}

export const SportMeetingsList = observer('SportMeetingsList', (propsIn: PropsType) => {
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;
    const props = useAsObservableSource(propsIn);
    const { sport, isBuilding, isLoading, selected, onChoose, filterType } = props;
    const { sportHorseracingMeetingsSplitByCountry, sportGreyhoundMeetingsSplitByCountry, filtersVersion } =
        configState;

    const [state] = useState(() => new SportMeetingsListState(props, common));
    const [filtersState] = useState(
        () => new FiltersState(new SportMeetingsListFilterStrategy(state, LanguagesState.get(common).getTranslation))
    );

    return (
        <SportMeetingsListWrapper variant={configState.componentVariants.sportsbookVariant}>
            <SportMeetingsFiltersWrapper variant={configState.componentVariants.sportsbookVariant}>
                <FiltersScrollableWrapper>
                    <Filters
                        state={filtersState}
                        skin={filtersVersion.football}
                    />
                </FiltersScrollableWrapper>
            </SportMeetingsFiltersWrapper>
            <RaceWrapper variant={configState.componentVariants.sportsbookVariant}>
                {sport === 'horseracing' ? (
                    sportHorseracingMeetingsSplitByCountry ? (
                        <SportMeetingsListByCountry
                            state={state}
                            isBuilding={isBuilding}
                            isLoading={isLoading}
                            selected={selected}
                            onChoose={onChoose}
                            sport={sport}
                            filterType={filterType}
                        />
                    ) : (
                        <SportMeetingsListDefault
                            state={state}
                            isBuilding={isBuilding}
                            isLoading={isLoading}
                            selected={selected}
                            onChoose={onChoose}
                            sport={sport}
                        />
                    )
                ) : sportGreyhoundMeetingsSplitByCountry ? (
                    <SportMeetingsListByCountry
                        state={state}
                        isBuilding={isBuilding}
                        isLoading={isLoading}
                        selected={selected}
                        onChoose={onChoose}
                        sport={sport}
                        filterType={filterType}
                    />
                ) : (
                    <SportMeetingsListDefault
                        state={state}
                        isBuilding={isBuilding}
                        isLoading={isLoading}
                        selected={selected}
                        onChoose={onChoose}
                        sport={sport}
                    />
                )}
            </RaceWrapper>
        </SportMeetingsListWrapper>
    );
});
